// extracted by mini-css-extract-plugin
export var button = "_gy-0";
export var donut = "_gy-1";
export var donutFill = "_gy-3";
export var donutTrack = "_gy-2";